import React from "react";
import LogoHeader from "../components/logo-header-view";

export const LogoHeaderContainer = () => {
  return <LogoHeader />;
};

export default LogoHeaderContainer;
